@if (!isEditing) {
	<app-data-set #dataSet [dataSource]="dataSource" defaultPresentationMode="table" firstColumnProperty="firstName">
		<app-data-set-content>
			<app-data-set-table-view-without-paginator>
				@if (loadingService.isLoading(getContactsLoadingKey) || !finishedLoadingInitData) {
					<app-data-set-loading-row />
				}
				<table
					mat-table
					[dataSource]="dataSource"
					matSort
					[hidden]="loadingService.isLoading(getContactsLoadingKey) || !finishedLoadingInitData"
				>
					<tr class="mat-row" *matNoDataRow>
						<td [colSpan]="displayedColumns.length" class="mat-cell" i18n="@@listOfContact-noRecordsFound">
							No records found
						</td>
					</tr>
					<ng-container matColumnDef="firstName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@listOfContact-firstName">First Name</th>
						<td mat-cell *matCellDef="let row">{{ row.firstName }}</td>
					</ng-container>
					<ng-container matColumnDef="lastName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@listOfContact-lastName">Last Name</th>
						<td mat-cell *matCellDef="let row">{{ row.lastName }}</td>
					</ng-container>
					<ng-container matColumnDef="email">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@listOfContact-email">Email</th>
						<td mat-cell *matCellDef="let row">{{ row.email }}</td>
					</ng-container>
					@if (visibleIfSMSNotification) {
						<ng-container matColumnDef="mobileNumber">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@listOfContact-mobileNumber">
								Mobile Number
							</th>
							<td mat-cell *matCellDef="let row">
								{{ row.phoneNumber.countryCode }} {{ row.phoneNumber | phoneNumber }}
							</td>
						</ng-container>
					}
					<ng-container matColumnDef="onOff">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@listOfContact-onOff">On/Off</th>
						<td mat-cell *matCellDef="let row">
							@if (row?.active) {
								<span i18n="@@listOfContact-status-on">On</span>
							} @else {
								<span i18n="@@listOfContact-status-off">Off</span>
							}
						</td>
					</ng-container>
					<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
					<tr
						mat-row
						*matRowDef="let row; columns: displayedColumns"
						[attr.data-automation-id]="'contact-' + row.id + '-row'"
					></tr>
				</table>
			</app-data-set-table-view-without-paginator>
		</app-data-set-content>
	</app-data-set>
}
